import api from './api';

export const getSiteSettings = async () => {
  try {
    const response = await api.get('/api/MainPageSettings/GetSiteSettings');
    return response;
  } catch (error) {
    console.error('Error fetching site settings:', error);
    throw error;
  }
};

export const updateSiteSettings = async (settings) => {
  try {
    const response = await api.post('/api/MainPageSettings/UpdateSiteSettings', settings);
    return response;
  } catch (error) {
    console.error('Error updating site settings:', error);
    throw error;
  }
};
